import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';

export default function ApprovalCountDetailsTable({ data }) {
  const getData = (countryCode, periodData) => {
    const countries = _.get(periodData, 'countries', []);
    const country = _.find(countries, ['country', countryCode]);
    const statusCounts = _.get(country, 'statusCounts', []);
    const rejected = _.find(statusCounts, ['status', 'REJECTED']);
    const approved = _.find(statusCounts, ['status', 'APPROVED']);
    return { rejected: _.get(rejected, 'count', '-'), approved: _.get(approved, 'count', '-') };
  };
  const countryFilters = [
    { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' },
    { code: 'IT', name: 'Italy' },
    { code: 'ES', name: 'Spain' },
  ];

  const getTotals = (itemsData, countryCode) => {
    const allCountries = _.map(itemsData, 'countries');
    const groupedByCountry = _.groupBy(_.flatten(allCountries), 'country');
    const statusCounts = _.map(groupedByCountry, group => {
      const totalApproved = _.sumBy(group, g => {
        const approved = _.find(g.statusCounts, ['status', 'APPROVED']);
        return _.get(approved, 'count', 0);
      });
      const totalRejected = _.sumBy(group, g => {
        const rejected = _.find(g.statusCounts, ['status', 'REJECTED']);
        return _.get(rejected, 'count', 0);
      });
      const approved = totalApproved;
      const rejected = totalRejected;
      return { country: _.get(group, '[0].country', '-'), approved, rejected };
    });

    return _.find(statusCounts, ['country', countryCode]);
  };

  const itemDate = item => moment(item.date);
  return (<Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Date</Table.HeaderCell>
        {_.map(countryFilters, country =>
          <Table.HeaderCell key={country.code} colSpan="2">{country.name}</Table.HeaderCell>)
        }
      </Table.Row>
      <Table.Row>
        <Table.HeaderCell />
        <Table.HeaderCell>Approved</Table.HeaderCell>
        <Table.HeaderCell>Rejected</Table.HeaderCell>
        <Table.HeaderCell>Approved</Table.HeaderCell>
        <Table.HeaderCell>Rejected</Table.HeaderCell>
        <Table.HeaderCell>Approved</Table.HeaderCell>
        <Table.HeaderCell>Rejected</Table.HeaderCell>
        <Table.HeaderCell>Approved</Table.HeaderCell>
        <Table.HeaderCell>Rejected</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>

      {!_.isEmpty(data) &&
        _.map(_.orderBy(data, itemDate, ['desc']), item =>
          <Table.Row key={item.date}>
            <Table.Cell>
              {item.date}
            </Table.Cell>
            <Table.Cell>
              {getData('DE', item).approved}
            </Table.Cell>
            <Table.Cell>
              {getData('DE', item).rejected}
            </Table.Cell>
            <Table.Cell>
              {getData('FR', item).approved}
            </Table.Cell>
            <Table.Cell>
              {getData('FR', item).rejected}
            </Table.Cell>
            <Table.Cell>
              {getData('IT', item).approved}
            </Table.Cell>
            <Table.Cell>
              {getData('IT', item).rejected}
            </Table.Cell>
            <Table.Cell>
              {getData('ES', item).approved}
            </Table.Cell>
            <Table.Cell>
              {getData('ES', item).rejected}
            </Table.Cell>
          </Table.Row>,
        )
      }

    </Table.Body>
    {!_.isEmpty(data) &&
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell>
          Total
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'DE'), 'approved', '-')}
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'DE'), 'rejected', '-')}
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'FR'), 'approved', '-')}
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'FR'), 'rejected', '-')}
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'IT'), 'approved', '-')}
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'IT'), 'rejected', '-')}
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'ES'), 'approved', '-')}
          </Table.HeaderCell>
          <Table.HeaderCell >
            {_.get(getTotals(data, 'ES'), 'rejected', '-')}
          </Table.HeaderCell>

        </Table.Row>
      </Table.Footer>
    }
  </Table>);
}

ApprovalCountDetailsTable.propTypes = {
  data: PropTypes.array,
};
ApprovalCountDetailsTable.defaultProps = {
  data: [],
};



/** WEBPACK FOOTER **
 ** ./src/components/approval-count-details-table/index.js
 **/